import { call, put, takeEvery } from "redux-saga/effects";
import * as constClass from "../../../common/constant/constantURL";
import { getCall, postCall } from "../../../helpers/fakebackend_helper";
import {
  GET_OFFER_DETAILS,
  GET_TEMPLATE_DETAILS,
  REVOKE_OFFER_LETTER,
  SAVE_OFFER_DETAILS,
  SHOW_OFFER_LETTER,
} from "./actionTypes";
import {
  getOfferDetailsSuccess,
  getTemplateLetterDataSuccess,
  offerCommonError,
  offerCommonSuccess,
  showOfferLetterFailed,
  showOfferLetterSuccess
} from "./actions";
// get candidate hiring details
function* getOfferCandiateData({ payload: { jobId, candidateId } }) {
  try {
    const url =
      constClass.REST_API_GEN_OFFER_LETTER +
      `?jobId=${jobId}&candidateId=${candidateId}`;
    let responsJSON = yield call(getCall, url);
    yield put(getOfferDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(offerCommonError(error));
  }
}

function* saveOfferDetails({ payload: data }) {
  try {
    let url = constClass.REST_API_GEN_OFFER_LETTER;
    let responsJSON = yield call(postCall, url, data.data);
    yield put(offerCommonSuccess(responsJSON.message));
  } catch (error) {
    yield put(offerCommonError(error));
  }
}

function* getTemplateDetailsFunc({ payload: { data } }) {
  try {
    let url = "";
    if (data !== undefined) {
      url =
        constClass.REST_API_TEMPLATE_OFFER_LETTER +
        "?pageSize=50&page=0&jobId=" +
        data;
    } else {
      url = constClass.REST_API_TEMPLATE_OFFER_LETTER + "?pageSize=50&page=0";
    }
    let responsJSON = yield call(getCall, url);
    yield put(getTemplateLetterDataSuccess(responsJSON));
  } catch (error) {
    yield put(offerCommonError(error));
  }
}

function* revokeOfferLetterFunc({ payload: { id } }) {
  try {
    const url = constClass.REST_API_FOR_EDIT_OFFER_LETTER;
    let responsJSON = yield call(postCall, url, { id: id });
    yield put(offerCommonSuccess(responsJSON.message));
  } catch (error) {
    yield put(offerCommonError(error));
  }
}

function* showOfferLetterHandler(data){
  try{
    let url=constClass.REST_API_SHOW_OFFER_LETTER+data.payload
    let responsJSON=yield call(getCall,url)
    yield put(showOfferLetterSuccess(responsJSON))

  }
  catch(error){
   
    yield put(showOfferLetterFailed(error))
  }
}

function* OfferSaga() {
  yield takeEvery(GET_OFFER_DETAILS, getOfferCandiateData);
  yield takeEvery(SAVE_OFFER_DETAILS, saveOfferDetails);
  yield takeEvery(GET_TEMPLATE_DETAILS, getTemplateDetailsFunc);
  yield takeEvery(REVOKE_OFFER_LETTER, revokeOfferLetterFunc);
  yield takeEvery(SHOW_OFFER_LETTER,showOfferLetterHandler)
}
export default OfferSaga;
